export default class messagesService {
    private _counter = 0;
    private _checked: message[] = [];
    private _unchecked: message[] = [];
    constructor() {
    }

    danger(message: string, header?: string) {
        this.createMessage(message, 'danger', header);
    }

    warning(message: string, header?: string) {
        this.createMessage(message, 'warning', header);
    }

    info(message: string, header?: string) {
        this.createMessage(message, 'info', header);
    }

    success(message: string, header?: string) {
        this.createMessage(message, 'success', header);
    }

    createMessage(message: string|Array<string>, type: messageType, header?: string) {
        type = type || 'danger';
        this._unchecked.push({
            id: ++this._counter,
            header,
            text: typeof message == "string" ? message : message[0],    // sometimes message is an array
            type,
            time: new Date(),
            checked: false
        });
    }


    all() {
        return this._checked.concat(this._unchecked);
    }

    unchecked() {
        return this._unchecked;
    }

    check(id: number) {
        for (let i = 0; i < this._unchecked.length; i++) {
            if (this._unchecked[i].id == id) {
                this._unchecked[i].checked = true;
                this._checked.push(this._unchecked[i]);
                this._unchecked.splice(i, 1);
                break;
            }
        }
    }

    checkAll() {
        this._checked = this._checked.concat(this._unchecked);
        this._unchecked.length = 0;
        this._checked.forEach(function(msg) {
            msg.checked = true;
        });
    }
}

export type messageType = 'success' | 'info' | 'warning' | 'danger';

export interface message {
    id: number,
    header: string,
    text: string,
    type: messageType,
    time: Date,
    checked: boolean
}


